import styles from "./ServiceKinds.module.css"
import lensImg from '../../images/lensImg.webp'
import pcImg from '../../images/pcImg.webp'
import carFixImg from '../../images/carFixImg.webp'
import keysImg from '../../images/keysImg.webp'
import crossImg from '../../images/crossImg.webp'
import { useEffect, useState } from "react"

export default function Servicekinds(){

  const [serviceType, setServiceType] = useState('')
  //Состояние слайдера карточки и обработчик
  const [activeCard, setActiveCard] = useState(null);

  const handleDetailsClick = (id) => {
    setActiveCard(activeCard === id ? null : id);
  };

  //Состояние уведомления отправки формы
  const [popupOpen, setPopupOpen] = useState(false)
  useEffect(() => {
  }, [popupOpen])

  const closePopup = () => {
    setPopupOpen(false);
  }

  const [orderOpen, setOrderOpen] = useState(false)
  useEffect(() => {
  }, [orderOpen])

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      car: serviceType, // Обновляем поле car после изменения serviceType
    }));
  }, [serviceType]); // Зависимость от serviceType

  const handleOrderClick = (optionNum) => {
    const newServiceType = 
    optionNum === 1 ? 'Подбор под ключ' :
    optionNum === 2 ? 'Эксперт на день' :
    optionNum === 3 ? 'Разовая диагностика автомобиля' :
    optionNum === 4 ? 'Анализ рынка автомобилей' : '';
    setServiceType(newServiceType); // Обновляем serviceType
    setOrderOpen(true);
  };

  // const submitOrderPopup = (event) => {
  //   event.preventDefault(); // Останавливаем отправку формы
  //   setOrderOpen(false);
  //   setPopupOpen(true);
  // }

  const closeOrderPopup = () => {
    setOrderOpen(false);
  }

  const [formData, setFormData] = useState({
    car: "Заявка на подбор",
    phone: "",
    name: "",
  });

  // срабатывает каждый раз при вводе в поле данных
  //e - объект события, автоматически передающийся при изменении формы.
  //e.target - конкретный DOM элемент формы, который вызвал событие
  // name - атрибут поля ввода (car, name, phone)
  // value - текущее значение
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value, //Обновление поля в объекте formData по ключ:значение
    });
  };

  const submitOrderPopup = async (event) => {
    event.preventDefault(); // Останавливаем отправку формы

    try {
      const response = await fetch("/api/sendToTelegram.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setOrderOpen(false);
        setPopupOpen(true); // Показываем попап
        // setFormData({
        //   car: "",
        //   phone: "",
        //   name: "",
        // })
      } else {
        console.error("Ошибка при отправке данных");
      }
    } catch (error) {
      console.error("Ошибка:", error);
    }
  };

  return(
    <div className={styles.serviceKinds}>
      <h3 className={styles.serviceKinds__title}>Виды услуг</h3>
      <div className={styles.cardsContainer}>
        <div className={styles.card}>
          <img className={styles.card__img_1} src={keysImg} alt="" />
          <div 
            className={`${styles.card__content} ${activeCard === 1 ? styles.card__content_active : ""}`}
          >
            <h4 className={styles.card__title}>
              Подбор автомобиля<br />
              с пробегом под ключ
            </h4>
            {/* <p className={styles.card__price}>Стоимость услуги: от 10.000 р.</p> */}
            <button className={styles.card__button} onClick={() => handleOrderClick(1)}>Заказать сейчас</button>
            <button className={styles.card__button} onClick={() => handleDetailsClick(1)}>Подробнее</button>
            <p className={`${styles.card__description} ${activeCard === 1 ? styles.card__description_active : ""}`}>
              Мы берём на себя все этапы — от поиска подходящих вариантов до передачи ключей. Автомобиль тщательно проверяется на юридическую чистоту и техническое состояние, а также проходит диагностику. Мы торгуемся за лучшую цену. Вы получаете надёжный автомобиль без лишних хлопот.
            </p>
          </div>
        </div>
        <div className={styles.card}>
          <img className={styles.card__img_2} src={carFixImg} alt="" />
          <div 
            className={`${styles.card__content} ${activeCard === 2 ? styles.card__content_active : ""}`}
          >
            <h4 className={styles.card__title}>
              Эксперт <br />на день
            </h4>
            {/* <p className={styles.card__price}>Стоимость услуги: от 10.000 р.</p> */}
            <button className={styles.card__button} onClick={() => handleOrderClick(2)}>Заказать сейчас</button>
            <button className={styles.card__button} onClick={() => handleDetailsClick(2)}>Подробнее</button>
            <p className={`${styles.card__description} ${activeCard === 2 ? styles.card__description_active : ""}`}>
              Наш эксперт станет вашим личным помощником на один день. 
              Он проверит техническое состояние, юридическую чистоту и проведёт диагностику понравившихся автомобилей. 
              С нами вы избежите рисков и получите профессиональное мнение, чтобы принять правильное решение.
            </p>
          </div>
        </div>
      </div>
      <div className={styles.cardsContainer}>
        <div className={styles.card} >
          <img className={styles.card__img_3} src={pcImg} alt="" />
          <div 
            className={`${styles.card__content} ${activeCard === 3 ? styles.card__content_active : ""}`}
          >
            <h4 className={styles.card__title}>
              Разовая диагностика<br />
              автомобиля
            </h4>
            {/* В случае разблока поменять отступы и порядок цветов */}
            {/* <p className={styles.card__price}>Стоимость услуги: от 10.000 р.</p> */}
            <button className={styles.card__button} onClick={() => handleOrderClick(3)}>Заказать сейчас</button>
            <button className={styles.card__button} onClick={() => handleDetailsClick(3)}>Подробнее</button>
            <p className={`${styles.card__description} ${activeCard === 3 ? styles.card__description_active : ""}`}>
              Тщательно проверим выбранный автомобиль перед покупкой. 
              Наши специалисты оценивают техническое состояние, проверяют юридическую чистоту, анализируют историю эксплуатации и выявляют скрытые дефекты. 
              Вы получите полный отчёт, чтобы быть уверенным в своём решении.
            </p>
          </div>
        </div>
        <div className={styles.card}>
          <img className={styles.card__img_4} src={lensImg} alt="" />
          <div 
            className={`${styles.card__content} ${activeCard === 4 ? styles.card__content_active : ""}`}
          >
            <h4 className={styles.card__title}>
              Анализ рынка<br />
              автомобилей
            </h4>
            {/* <p className={styles.card__price}>Стоимость услуги: от 10.000 р.</p> */}
            <button className={styles.card__button} onClick={() => handleOrderClick(4)}>Заказать сейчас</button>
            <button className={styles.card__button} onClick={() => handleDetailsClick(4)}>Подробнее</button>
            <p className={`${styles.card__description} ${activeCard === 4 ? styles.card__description_active : ""}`}>
              Мы проводим глубокий анализ рынка, чтобы найти лучшие предложения, соответствующие вашим требованиям и бюджету. 
              Оцениваем актуальные цены, популярные модели и оптимальные варианты с точки зрения качества и стоимости. 
              Это поможет вам сэкономить время и выбрать автомобиль с выгодными условиями.
            </p>
          </div>
        </div>
      </div>
      <div className={orderOpen?styles.orderPopupOpen:styles.orderPopupClose}>
        <form className={styles.orderPopup} onSubmit={submitOrderPopup}>
          <img className={styles.orderPopup__cross} onClick={closeOrderPopup} src={crossImg} alt="" />
          <p className={styles.orderPopup__title}>Заполните форму</p>
          <p className={styles.orderPopup__text}>Пожалуйста, оставьте свои данные, что бы мы связались с вами.</p>
          <input className={styles.orderPopup__input} placeholder="Ваше имя" name="name" onChange={handleChange} type="text" required/>
          <input className={styles.orderPopup__input} placeholder="Ваш номер" name="phone" onChange={handleChange} type="phone" required/>
          <button className={styles.orderPopup__button}>Оставить заявку</button>
        </form>
      </div>
      <div className={popupOpen?styles.popupOpen:styles.popupClose}>
        <div className={styles.popup}>
          <p className={styles.popup__title}>Спасибо!</p>
          <p className={styles.popup__text}>Мы уже получили Вашу заявку и ответим Вам в течение 15 минут.</p>
          <p className={styles.popup__text}>Не хотите ждать? Позвоните нам:  <br />8-993-983-89-98</p>
          <button className={styles.popup__button} onClick={closePopup}>Отлично!</button>
        </div>
      </div>
    </div>
  )
}